

export var Method; (function (Method) {
  const GET = 'GET'; Method["GET"] = GET;
  const POST = 'POST'; Method["POST"] = POST;
  const DELETE = 'DELETE'; Method["DELETE"] = DELETE;
  const PUT = 'PUT'; Method["PUT"] = PUT;
})(Method || (Method = {}));

// Configure your proxy target on app-config.yaml or 
// app-config.[production | development].yaml file under proxy field
// example below: 
//  proxy:
//    '/test':
//       target: 'https://example.com'
export var PROXY_TARGETS; (function (PROXY_TARGETS) {
  const devportal = 'devportal'; PROXY_TARGETS["devportal"] = devportal;
})(PROXY_TARGETS || (PROXY_TARGETS = {}));












export class ProxyFetch {
    target;
    discoveryApi;

  constructor(options) {
    this.target = options.target;
    this.discoveryApi = options.discoveryApi;
  }

  async fetchApi (endpoint, fetchParams) {
    const proxyBackendBaseUrl = await this.discoveryApi.getBaseUrl("proxy");
    const url = `${proxyBackendBaseUrl}/${this.target}/${endpoint}`;

    return fetch(url, { ...fetchParams });
  }
}